import { useMemo } from "react";

import ultrabulletIcon from "src/assets/icons/ultraBulllet.svg";
import rabbitIcon from "src/assets/icons/rabbit.svg";
import bulletIcon from "src/assets/icons/Bullet.svg";
import flashIcon from "src/assets/icons/lightning.svg";
import snailIcon from "src/assets/icons/snail.svg";

import { GameCreateTime } from "src/store/models";

import { Divider } from "../../Divider";

import { useStyles } from "./styles";
import { useLocale } from "../../../../../providers/LocaleProvider";

interface ITimeProps {
    time: GameCreateTime;
    isMobile?: boolean;
}

export const Time = ({ time, isMobile }: ITimeProps) => {
    const classes = useStyles();

    const {
        lobby: {
            time: { min },
        },
    } = useLocale();

    const renderIconUrl = () => {
        switch (time) {
            case 2:
                return ultrabulletIcon;
            case 3:
                return bulletIcon;
            case 5:
                return flashIcon;
            case 10:
                return rabbitIcon;
            case 20:
                return snailIcon;
            default:
                throw new Error(`unknown time: ${time}`);
        }
    };

    const renderTextUrl = () => {
        switch (time) {
            case 1:
                return `1 ${min("min")}`;
            case 2:
                return `2 ${min("min")}`;
            case 3:
                return `3 ${min("min")}`;
            case 5:
                return `5 ${min("min")}`;
            case 10:
                return `10 ${min("min")}`;
            case 20:
                return `20 ${min("min")}`;
            default:
                throw new Error(`unknown time: ${time}`);
        }
    };

    const renderIconUrlMemo = useMemo(() => renderIconUrl(), [time]);
    const renderTextUrlMemo = useMemo(() => renderTextUrl(), [time]);

    if (isMobile) {
        return (
            <div className={classes.wrapperTime}>
                <img src={renderIconUrlMemo} className={classes.timeIcon} />
            </div>
        );
    }

    return (
        <div className={classes.wrapperTime}>
            <Divider left={0} />
            <img src={renderIconUrlMemo} className={classes.timeIcon} />
            <span className={classes.timeLabel}>{renderTextUrlMemo}</span>
            <Divider right={0} />
        </div>
    );
};
